import React, { useState } from 'react'

function RegularDonation() {
    const [value, setValue] = useState(16);

    const handleChange = (e) => {
        setValue(e.target.value);
    };
    const items = Array.from({ length: 3 }, (_, index) => ({
        id: index + 1,
        name: "Kiki Anne",
        date: "May 20, 2024",
        title: "Help flood victim",
        raised: "$2,400",
        daysLeft: 22,
    }));

    return (
        <>
            <div>
                <h6 className="font-[700] font-manrope text-[24px] text-[#000000] pb-[19px]">Donation History</h6>
                <div className='bg-[#F6F8FA] border border-[#E7E4FC] rounded-[12px] p-[30px]'>
                    <div className="grid grid-cols-1 gap-y-[20px]">
                        {items.map((item) => (
                            <div key={item.id} className="flex flex-col gap-[30px] w-full">
                                <div className='flex gap-[13px] lg:flex-row flex-col items-start w-full'>
                                    <img src="/assets/impact/img4.png" alt="" />
                                    <div className='w-full'>
                                        <div className="flex justify-between items-center w-full">
                                            <p className="font-[600] font-manrope text-[16px] text-[#4D4D4D]">{item.name}</p>
                                            <p className="font-[400] font-manrope text-[16px] text-[#4D4D4D]">{item.date}</p>
                                        </div>
                                        <h6 className="pt-[5px] font-[700] font-manrope text-[20px] text-[#333333]">{item.title}</h6>
                                        <input
                                            type="range"
                                            min="0"
                                            max="100"
                                            value={value}
                                            onChange={handleChange}
                                            className="w-full accent-[#FF6000]"
                                        />
                                        <div className='flex justify-between items-center'>
                                            <div>
                                                <p className="font-[400] font-manrope text-[11px] text-[#666666]">Raised</p>
                                                <h6 className="font-[700] font-manrope text-[20px] text-[#141414]">{item.raised}</h6>
                                            </div>
                                            <div>
                                                <p className="font-[400] font-manrope text-right text-[11px] text-[#666666]">Days left</p>
                                                <h6 className="font-[700] font-manrope text-right text-[20px] text-[#141414]">{item.daysLeft}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex justify-between lg:flex-row flex-col lg:gap-0 gap-[20px] items-center'>
                                   <p className="font-[400] font-manrope text-[16px] text-[#141414]">You have donated $20</p>
                                    <button className='d-btn !shadow-none !capitalize'>Donate Again</button>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </>
    )
}

export default RegularDonation